/* eslint-disable prettier/prettier */
import { createSlice } from "@reduxjs/toolkit";

export const rolesSlice = createSlice({
  name: "roles",
  initialState: {
    rolesUsuarios: [],
    isloadingRoles: true,
    grupos: [],
    permisos: [],
  },
  reducers: {
    getroles: (state, action) => {
      state.rolesUsuarios = action.payload.roles;
      state.grupos = action.payload.grupos;
      state.permisos = action.payload.permisos;
    },
    isLoadingRoles: (state, action) => {
      state.isloadingRoles = action.payload;
    },
    closeAlert: (state, action) => {
      state.alert.type = "";
      state.alert.message = "";
      state.alert.show = false;
    },
    setRolAdd: (state, action) => {
      state.rolesUsuarios.unshift(action.payload);
      state.alert = {
        type: "success",
        message: "Rol agregado correctamente",
        show: true,
      };
    },
    updateRolSuccess: (state, action) => {
      const index = state.rolesUsuarios.findIndex(
        (r) => r.idRolUsuario === action.payload.idRolUsuario
      );
      if (index !== -1) {
        state.rolesUsuarios[index] = action.payload;
      }
      state.alert = {
        type: "success",
        message: "Rol actualizado correctamente",
        show: true,
      };
    },
    updateStatusSuccess: (state, action) => {
      const index = state.rolesUsuarios.findIndex(
        (r) => r.idRolUsuario === action.payload.idRolUsuario
      );
      if (index !== -1) {
        state.rolesUsuarios[index].activo = action.payload.activo;
      }
      state.alert = {
        type: "success",
        message: "Estado del rol actualizado",
        show: true,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getroles,
  closeAlert,
  setRolAdd,
  updateRolSuccess,
  updateStatusSuccess,
  isLoadingRoles,
} = rolesSlice.actions;

export default rolesSlice.reducer;
